import React, { useEffect } from 'react';
import ModalBackdrop from './Components/Modal/ModalBackdrop.tsx';
import ModalContent from './Components/Modal/ModalContent.tsx';
import PortalContainer from './Components/FitAssistantButton/PortalContainer.tsx';
import StepRouter from './StepResolver.tsx';
import { useAppState } from './State.tsx';

const Panniers = () => {
  const { showFitAssistant, setShowFitAssistant } = useAppState();

  const html: HTMLElement | null = document.querySelector('html');
  const body: HTMLElement | null = document.querySelector('body');
  const thuleWidget: HTMLElement | null = document.querySelector('div[data-thule-widget]');

  const params = new URLSearchParams(window.location.search);

  useEffect(() => {
    if (params.has('openFa')) setShowFitAssistant(true);
  }, []);

  useEffect(() => {
    if (showFitAssistant) {
      html?.classList.add('overflow-hidden');
      body?.classList.add('overflow-hidden');
      if (thuleWidget) thuleWidget.style.display = 'none';
    } else {
      html?.classList.remove('overflow-hidden');
      body?.classList.remove('overflow-hidden');
      if (thuleWidget) thuleWidget.style.display = 'inline';
    }
  }, [showFitAssistant]);

  return (
    <>
      <PortalContainer />
      <ModalContent>
        <StepRouter />
      </ModalContent>
      <ModalBackdrop />
    </>
  );
};

export default Panniers;
